package ru.villawonka.app.domain.service

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow
import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.domain.model.PostDomain
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.domain.usecase.DislikePostUseCase
import ru.villawonka.app.domain.usecase.LikePostUseCase
import ru.villawonka.app.domain.usecase.RequestFavoritePostsUseCase

class FavoritesService(
    private val likePostUseCase: LikePostUseCase,
    private val dislikePostUseCase: DislikePostUseCase,
    private val requestFavoritePostsUseCase: RequestFavoritePostsUseCase,
) {
    private val _toggleLikeEvents = MutableSharedFlow<Pair<Int, Boolean>>()
    val toggleLikeEvents = _toggleLikeEvents.asSharedFlow()

    private val _favoritePosts = MutableSharedFlow<Either<NetworkFailure, List<PostDomain>>>(
        replay = 1
    )
    val favoritePosts = _favoritePosts.asSharedFlow()

    suspend fun toggleLike(postId: Int, postType: PostTypeDomain, isLiked: Boolean) {
        _toggleLikeEvents.emit(postId to isLiked)

        if (isLiked) {
            likePostUseCase(postId, postType)
        } else {
            dislikePostUseCase(postId, postType)
        }

        remoteSync()
    }

    suspend fun remoteSync() {
        _favoritePosts.emit(requestFavoritePostsUseCase(PostTypeDomain.ACCOMMODATION))
    }
}